import Counter from "ds/components/Counter";
import { TreeBranch, TreeItem } from "ds/components/Tree";
import { PlanPoliciesOutcome } from "types/generated";
import { useToggle } from "hooks/useToggle";
import CardCollapsible from "ds/components/Card/Collapsible";

import styles from "./styles.module.css";
import Message from "./Message";

type MessagesProps = {
  outcome: PlanPoliciesOutcome;
};

function Messages({ outcome }: MessagesProps) {
  const [isCollapsed, toggle] = useToggle(false);

  const count = outcome.deny.length + outcome.warn.length + outcome.info.length;

  return (
    <TreeBranch className={styles.messagesWrapper}>
      <TreeItem direction="column" autoHeight align="start">
        <CardCollapsible
          ariaLevel={4}
          ariaLabel="Messages"
          title="Messages"
          size="small"
          titleSuffix={<Counter count={count} />}
          isCollapsed={isCollapsed}
          onToggle={toggle}
          fullbleed
        >
          {outcome.deny.map((message, index) => (
            <Message key={index} text={message} type="deny" />
          ))}
          {outcome.warn.map((message, index) => (
            <Message key={index} text={message} type="warn" />
          ))}
          {outcome.info.map((message, index) => (
            <Message key={index} text={message} type="info" />
          ))}
        </CardCollapsible>
      </TreeItem>
    </TreeBranch>
  );
}

export default Messages;
